<template lang="pug">
.form-user.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.dni" autocomplete="ño"  type="number" min="1" :title="warnings.DNI" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.dni }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="dni" title="Documento de Identidad")

      .input-container
        input.input(v-model="dataForm.name" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.name }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="name" title="Nombre")

      .input-container
        input.input(v-model="dataForm.alias" autocomplete="ño")
        label.label(:class="{ show: dataForm.alias }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="alias" title="Alias")

      .input-container.arrow
        select.select(v-model="dataForm.type" autocomplete="ño" required)
          option(v-for="type in types" :value="type") {{ capitalize(type) }}
        label.label(:class="{ show: dataForm.type }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="type" title="Tipo")

    .divider

    .form-section
      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Dirección" property="addresses" type="text" :required="1")

    .divider

    .form-section
      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Email" property="emails" type="email" :required="1")

    .divider

    .form-section
      shInputList(:dataForm="dataForm" :dataOriginal="dataOriginal" title="Teléfono" property="phones" pattern="[0-9]{10}" :required="1")

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`active${dataForm.dni}`")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="active" title="Activo")
          input.input-checkbox(v-model="dataForm.active" :id="`active${dataForm.dni}`" type="checkbox")
          .checkmark

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`showInPage${dataForm.dni}`")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="showInPage" title="Mostrar en Ecommerce")
          input.input-checkbox(v-model="dataForm.showInPage" :id="`showInPage${dataForm.dni}`" type="checkbox")
          .checkmark

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteUser")

  form(@submit.prevent="" autocomplete="off")
    .input-container
      input.input(v-model.number="addBalance.value" type="number" min="0" max="6000000" autocomplete="ño" required)
      label.label(:class="{ show: addBalance.value }") Valor

    .input-container.arrow
      select.select(v-model="addBalance.add" autocomplete="ño" required)
        option(:value="true") Agregar
        option(:value="false") Restar
      label.label(:class="{ show: typeof addBalance.add === 'boolean' }") Tipo

    shActionButton(:isForm="true" :text="addBalance.add ? 'Agregar Valor' : 'Restar Valor'" :textRunning="addBalance.add ? 'Agregando Valor' : 'Restando Valor'" :action="chargeBalance" :normalColor="true")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlUser from '@/graphql/user'
import shInputList from '@/components/elements/InputList'
import modals from '@my/store/modals'
import gql from '@my/graphql'

export default {
  name: 'FormUser',

  mixins: [mForm, mFilters, mDB],

  components: { shInputList },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        dni: '',
        name: '',
        type: '',
        addresses: [''],
        emails: [''],
        phones: [''],
        active: false,
        showInPage: false
      },
      addBalance: {
        value: '',
        add: true
      },
      types: ['root', 'admin', 'superviserSales', 'superviserWholesaler', 'superviserMarketing', 'counter', 'adviser', 'adviserMarketing', 'warehouse', 'delivery', 'wholesaler', 'customer', 'watcher', 'dropshipping'],
      resolver: 'user',
      key: 'dni',
      gql: gqlUser,
      delete: ['balance']
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newUser()
      } else {
        this.updateUser()
      }
    },

    newUser () {
      if (this.dataForm.type === 'root') {
        this.newData(this.gql, this.resolver, this.key, 'NEW_ROOT', 'newUserRoot')
      } else {
        this.newData(this.gql, this.resolver, this.key)
      }
    },

    updateUser () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteUser () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    async chargeBalance () {
      const mutation = gqlUser.CHARGE_BALANCE

      if (!this.dataForm.dni) return

      const response = await gql.mutate(mutation, { dni: this.dataForm.dni, value: this.addBalance.value, add: this.addBalance.add })

      if (response) modals.showMessage({ message: `Se ${this.addBalance.add ? 'agregó' : 'restó'} ${this.addBalance.value} al usuario ${this.dataForm.dni}` })

      this.addBalance.value = ''
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-user
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/user/Form.vue